import { MemberUtils, type Season } from "@shared/member.utils";
import styled from "styled-components";
import type { Course } from "../../../stores/course.store";
import type { Member } from "../../../stores/user.store";

const MemberInfoBox = styled.div`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
`;

const MemberName = styled.h3`
  font-size: 18px;
  margin: 0 0 8px 0;
  font-weight: bold;
`;

const MemberDetail = styled.p`
  font-size: 14px;
  margin: 4px 0;
  color: #666;
`;

type Props = {
  member: Member;
  currentSeason: Season;
  currentCourse: Course;
};

export const SubscriptionMemberInfo = ({
  member,
  currentSeason,
  currentCourse,
}: Props) => {
  const memberType = MemberUtils.getMemberType(
    member.date_of_birth,
    currentSeason
  );

  const memberTypeLabel =
    memberType === "adult" ? "Adulto" : memberType === "junior" ? "Junior" : "Baby";

  return (
    <MemberInfoBox>
      <MemberName>
        {member.first_name} {member.last_name}
      </MemberName>
      <MemberDetail>Tipologia: {memberTypeLabel}</MemberDetail>
      <MemberDetail>Corso: {currentCourse.title}</MemberDetail>
    </MemberInfoBox>
  );
};
